// extracted by mini-css-extract-plugin
module.exports = {"footers":"footer_footers__3xt10"};